import { roleCan, type Permission, type SessionUserDto } from '@tms/shared';
import { useCurrentUser } from './api';

/**
 * UI-side permission check. It hides actions the API would refuse anyway — the
 * API remains the authority, this only keeps the interface honest.
 */
export const userCan = (user: SessionUserDto | undefined, permission: Permission): boolean =>
  user ? roleCan(user.role, permission) : false;

export const usePermissions = () => {
  const { data: user } = useCurrentUser();
  return {
    user,
    can: (permission: Permission) => userCan(user, permission),
  };
};
